import { ActivitiesForm } from '@shared/models/activities-form';
import { CarForm } from '@shared/models/car-form';
import { FlightForm } from '@shared/models/flight-form';
import { HotelForm } from '@shared/models/hotel-form';
import { FormData } from '../../models/form-data';
import * as fromActions from '../actions/travel-search-form.actions';

export interface TravelSearchForm {
  flight: FormData<FlightForm>;
  hotel: FormData<HotelForm>;
  car: FormData<CarForm>;
  activities: FormData<ActivitiesForm>;
}

export function reducer(state: TravelSearchForm, action: fromActions.TravelSearchFormActions): TravelSearchForm {
  switch (action.type) {
    case fromActions.UPDATE_FLIGHT_FORM:
      return { ...state, flight: action.formData };
    case fromActions.UPDATE_HOTEL_FORM:
      return { ...state, hotel: action.formData };
    case fromActions.UPDATE_CAR_FORM:
      return { ...state, car: action.formData };
    case fromActions.UPDATE_ACTIVITIES_FORM:
      return { ...state, activities: action.formData };
    default:
      return state;
  }
}
